import React, { Fragment } from 'react';
import classNames from 'classnames'
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';

export default function MainLayout() {

    const Classes = classNames({
        "relative min-h-svh w-screen": true
    })

    return (
        <Fragment>
            <Header/>

            <main className={Classes}>
                <Outlet />
            </main>
        </Fragment>
    )
}
